var _g, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInspection05(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\uAD6C\\uC131_\\uC694\\uC18C_111_1",
    "data-name": "\\uAD6C\\uC131 \\uC694\\uC18C 111 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uAD6C\\uC131_\\uC694\\uC18C_110_1",
    "data-name": "\\uAD6C\\uC131 \\uC694\\uC18C 110 \\u2013 1"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_1580",
    "data-name": "\\uD0C0\\uC6D0 1580",
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#8a00e0"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_10370",
    "data-name": "\\uD328\\uC2A4 10370",
    d: "M-.421,4.084H-2.057v-8.4H.5L2.025,2.288,3.541-4.318H6.066v8.4H4.43V-1.6q0-.245.006-.687t.006-.681L2.851,4.084h-1.7L-.432-2.967q0,.239.006.681t.006.687Z",
    transform: "translate(8.057 10.318)",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInspection05);
export default __webpack_public_path__ + "static/media/inspection_05.2f1115cb8138cab15ea87c3ea8fd16a5.svg";
export { ForwardRef as ReactComponent };